import { ref } from 'vue';
import Request from '@/services/request';
import { CATEGORY_COMMISSION_CAMPAIGN_JOIN } from '@/utils/enum/endpoints';

const Req = new Request();

export default function useCategoryCommissionCampaignJoin() {
  const isLoading = ref(false);
  const error = ref(null);

  const join = async (campaignId) => {
    isLoading.value = true;
    error.value = null;

    try {
      const path = CATEGORY_COMMISSION_CAMPAIGN_JOIN.replace(
        '{campaignId}',
        String(campaignId),
      );

      const response = await Req.post(
        path,
        {},
        {
          baseURL: '/sellerofficeapi/rest',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        },
      );

      if (response.status === 200) {
        return { ok: true };
      }

      return { ok: false };
    } catch (err) {
      error.value = err || null;
      return {
        ok: false,
        error: err,
      };
    } finally {
      isLoading.value = false;
    }
  };

  return {
    isLoading,
    error,
    join,
  };
}
